import { RuleProps } from 'types/application';

export const SHAREHOLDERS_INFORMATION = 'shareholders-information';
export const STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION = 'structure-of-acra-entity-registered-information';
export const FINANCIAL_INFORMATION = 'financial-information';
export const MEANS_THROUGH_WHICH_USERS_GAIN_ACCESS_TO_SBO_NETWORK = 'means-through-which-users-gain-access-to-sbos-network';
export const COLLECTION_OF_PAYMENT = 'collection-of-payment';
export const DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED = 'description-of-purposed-service-and-market-served';
export const COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES =
    'commencement-of-provision-and-or-operation-of-telecommunication-services';
export const SYSTEM_CONFIGURATION_AND_OPERATION = 'system-configuration-and-operation';
export const TELECOMMUNICATION_PARTNERS = 'telecommunication-partners';
export const INTERNATIONAL_GATEWAYS = 'international-gateways';
export const OTHER_TECHNICAL_SUPPORT = 'other-technical-support';
export const NUMBERING_REQUIREMENT = 'numbering-requirement';
export const INFORMATION_OF_BOARD_OF_DIRECTORS_CEO = 'information-of-board-of-directors-ceo';
export const INFORMATION_OF_BOARD_OF_DIRECTORS_CEO_FROM_EDH_ACRA = 'information-of-board-of-directors-ceo-from-edh-acra';

export const PUBLIC_INTERNET_ACCESS_SERVICES = 'public-internet-access-services';
export const REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES = 'registration-for-public-internet-access-services';
export const PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID = 'public-internet-access-services-non-prepaid';
export const PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID = 'public-internet-access-services-prepaid';

export const OTHERS_SERVICES = 'others-services';
export const REGISTRATION_FOR_OTHER_SERVICES = 'registration-for-other-services';
export const OTHER_SERVICES_NON_PREPAID = 'other-services-non-prepaid';
export const OTHER_SERVICES_PREPAID = 'other-services-prepaid';

export const RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES = 'resale-of-local-leased-fixed-line-connectivity-services';
export const REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES =
    'registration-for-resale-of-local-leased-fixed-line-connectivity-services';
export const RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID =
    'resale-of-local-leased-fixed-line-connectivity-services-non-prepaid';
export const RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID =
    'resale-of-local-leased-fixed-line-connectivity-services-prepaid';

export const INTERNATIONAL_CALLING_CARD_SERVICES = 'international-calling-card-services';
export const REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES = 'registration-for-international-calling-card-services';
export const INTERNATIONAL_CALLING_CARD_SERVICES_PREPAID = 'international-calling-card-services-prepaid';

export const WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES = 'white-space-geo-location-database-services';
export const REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES = 'registration-for-white-space-geo-location-database-services';
export const WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES_PREPAID = 'white-space-geo-location-database-services-prepaid';

export const IP_TELEPHONY_SERVICES = 'ip-telephony-services';
export const REGISTRATION_FOR_IP_TELEPHONY_SERVICES = 'registration-for-ip-telephony-services';
export const IP_TELEPHONY_SERVICES_NON_PREPAID = 'ip-telephony-services-non-prepaid';
export const IP_TELEPHONY_SERVICES_PREPAID = 'ip-telephony-services-prepaid';

export const VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_SERVICES =
    'voice-and-data-services-with-masking-of-calling-line-identity-services';
export const REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY =
    'registration-for-voice-and-data-services-with-masking-of-calling-line-identity';
export const VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_PREPAID =
    'voice-and-data-services-with-masking-of-calling-line-identity-prepaid';

export const MACHINE_TO_MACHINE_SERVICES = 'machine-to-machine-services';
export const REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES = 'registration-for-machine-to-machine-services';
export const MACHINE_TO_MACHINE_NON_PREPAID = 'machine-to-machine-services-non-prepaid';
export const MACHINE_TO_MACHINE_PREPAID = 'machine-to-machine-services-prepaid';

export const INTERNET_BASED_VOICE_AND_DATA_SERVICES = 'internet-based-voice-and-data-services';
export const REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES = 'registration-for-internet-based-voice-and-data-services';
export const INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID = 'internet-based-voice-and-data-services-non-prepaid';
export const INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID = 'internet-based-voice-and-data-services-prepaid';

export const INTERNATIONAL_SIMPLE_RESALE_SERVICES = 'international-simple-resale-services';
export const REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES = 'registration-for-international-simple-resale-services';
export const INTERNATIONAL_SIMPLE_RESALE_SERVICES_NON_PREPAID = 'international-simple-resale-services-non-prepaid';
export const INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID = 'international-simple-resale-services-prepaid';

export const INTERNET_EXCHANGE_SERVICES = 'internet-exchange-services';
export const REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES = 'registration-for-internet-exchange-services';
export const INTERNET_EXCHANGE_SERVICES_NON_PREPAID = 'internet-exchange-services-non-prepaid';
export const INTERNET_EXCHANGE_SERVICES_PREPAID = 'internet-exchange-services-prepaid';

export const CALL_BACK_CALL_RE_ORIGINATION_SERVICES = 'call-back-call-re-origination-services';
export const REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES = 'registration-for-call-back-call-re-origination-services';
export const CALL_BACK_CALL_RE_ORIGINATION_SERVICES_PREPAID = 'call-back-call-re-origination-services-prepaid';

export const STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES = 'store-and-retrieve-value-addded-services';
export const REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES = 'registration-for-store-and-retrieve-value-addded-services';
export const STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES_PREPAID = 'store-and-retrieve-value-addded-services-prepaid';

export const STORE_AND_FORWARD_VALUE_ADDED_SERVICES = 'store-and-forward-value-addded-services';
export const REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES = 'registration-for-store-and-forward-value-addded-services';
export const STORE_AND_FORWARD_VALUE_ADDED_SERVICES_PREPAID = 'store-and-forward-value-addded-services-prepaid';

export const SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES = 'satellite-mobile-telephone-or-data-services';
export const REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES = 'registration-for-satellite-mobile-telephone-or-data-services';
export const SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES_PREPAID = 'satellite-mobile-telephone-or-data-services-prepaid';

export const RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES = 'resale-of-public-switched-telecommunication-services';
export const REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES =
    'registration-for-resale-of-public-switched-telecommunication-services';
export const RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES_PREPAID = 'resale-of-public-switched-telecommunication-services-prepaid';

export const VIRTUAL_PRIVATE_NETWORK_SERVICES = 'virtual-private-network-services';
export const REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES = 'registration-for-virtual-private-network-services';
export const VIRTUAL_PRIVATE_NETWORK_SERVICES_NON_PREPAID = 'virtual-private-network-services-non-prepaid';
export const VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID = 'virtual-private-network-services-prepaid';

export const LIVE_AUDIOTEX_SERVICES = 'live-audiotex-services';
export const REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES = 'registration-for-live-audiotex-services';
export const LIVE_AUDIOTEX_SERVICES_PREPAID = 'live-audiotex-services-prepaid';

export const MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES = 'mobile-virtual-network-operation-services';
export const REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES = 'registration-for-mobile-virtual-network-operation-services';
export const MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID = 'mobile-virtual-network-operation-services-non-prepaid';
export const MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID = 'mobile-virtual-network-operation-services-prepaid';

export const MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES = 'mobile-communication-on-aircraft-services';
export const REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES = 'registration-for-mobile-communication-on-aircraft-services';
export const MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES_PREPAID = 'mobile-communication-on-aircraft-services-prepaid';

export const MANAGED_DATA_NETWORK_SERVICES = 'managed-data-network-services';
export const REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES = 'registration-for-managed-data-network-services';
export const MANAGED_DATA_NETWORK_SERVICES_NON_PREPAID = 'managed-data-network-services-non-prepaid';
export const MANAGED_DATA_NETWORK_SERVICES_PREPAID = 'managed-data-network-services-prepaid';

export const NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES = 'number-portability-centralised-database-services';
export const REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES =
    'registration-for-number-portability-centralised-database-services';

export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_SBOI_APPLICATION = [
    {
        sectionID: SHAREHOLDERS_INFORMATION,
        sectionName: "Shareholder's Information",
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'shareholders-information',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'id-no',
                        header: 'ID Number',
                        type: 'text'
                    },
                    {
                        id: 'id-type',
                        header: 'ID Type',
                        type: 'text'
                    },
                    {
                        id: 'name',
                        header: 'Name',
                        type: 'text'
                    },
                    {
                        id: 'nationality',
                        header: 'Nationality',
                        type: 'text'
                    },
                    {
                        id: 'addresss',
                        header: 'Address',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION,
        sectionName: 'Structure of ACRA Entity Registered Information',
        fieldList: [
            {
                id: 'required-information-will-be-attached',
                mainLabel:
                    'Include parent company, where applicable, subsidiaries and other interests of the group in Singapore and abroad, details of the key personnel and management structure.',
                label: 'Required Information will be attached',
                type: 'text',
                span: 12
            },
            {
                id: 'question-one',
                mainLabel: 'Question 1',
                label: 'Have any of the directors/managers/partners (as defined in the Companies Act 1967/Limited Liability Partnership Act) been a director/manager/partner of an ACRA Entity which has gone into liquidation, placed in official receivership, or insolvent (whether while he was a director/manager/partner or within 3 years of his ceasing to be director/manager/partner)?',
                type: 'text',
                span: 12
            },
            {
                id: 'if-yes-question-one',
                label: 'If yes for Question 1, please provide details',
                type: 'text',
                span: 12
            },
            {
                id: 'question-two',
                mainLabel: 'Question 2',
                label: 'Have any of the directors/managers/partners been a director/manager/partner of an ACRA Entity whose telecommunications licence(s) has been revoked by IMDA for breach of licence condition(s) (whether while he was a director/manager/partner or within 3 years of his ceasing to be director/manager/partner)?',
                type: 'text',
                span: 12
            },
            {
                id: 'if-yes-question-two',
                label: 'If yes for Question 2, please provide details',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: FINANCIAL_INFORMATION,
        sectionName: 'Financial Information',
        fieldList: [
            {
                id: 'required-information-will-be-attached',
                mainLabel:
                    'Include planned capital expenditure for next three years of operations, and also include to include the following documents if you intend to collect monetary deposits or use prepaid cards (other than credit cards) for collection of payments from your customers:',
                mainSubLabel:
                    '[p] a) Document showing that the applicant has a paid-up capital of atleast $100,00. [/p] [p] b) Latest audited financial statement. [/p] [p] c) Source of funding for the proposed prepaid services. [/p] [p] d) Sample template design of prepaid cards (both sides). [/p] [p] e) Breakdown of monthly cash flow for the next three years of operations. [/p]',
                label: 'Required Information will be attached',
                type: 'text',
                span: 12
            },
            {
                id: 'financial-details',
                label: 'Financial Details',
                type: 'text',
                span: 12
            },
            {
                id: 'financial-from',
                label: 'From',
                type: 'text'
            },
            {
                id: 'financial-to',
                label: 'To',
                type: 'text'
            }
        ]
    },
    {
        sectionID: MEANS_THROUGH_WHICH_USERS_GAIN_ACCESS_TO_SBO_NETWORK,
        sectionName: "Means through which users gain access to SBO's network",
        fieldList: [
            {
                id: 'means-through-which-users-gain-access-to-sbos-network',
                label: '',
                type: 'lists',
                span: 12
            }
        ]
    },
    {
        sectionID: COLLECTION_OF_PAYMENT,
        sectionName: 'Collection of Payment',
        fieldList: [
            {
                id: 'collection-of-monetary-deposits-or-use-of-prepaid-cards',
                mainLabel: 'Collection of Monetary Deposits Or Use of Prepaid Cards',
                label: "Note: If 'No', there is no need to submit the document showing that the licensee has a paid-up capital of S$100,000 at the point of licensing. However, should the licensee subsequently decide to collect money deposits and/or to use prepaid cards for collection of payments from its customers, the licensee must seek IMDA's prior written approval and submit the document showing that it has a paid-up capital of at least S$100,000 at the point of licensing.",
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED,
        sectionName: 'Description of proposed service and market used',
        fieldList: [
            {
                id: 'please-attached-required-information',
                mainLabel:
                    'Describe the nature of the services and the service schemes to be offered (trade-name if any) for each service category marked above, expected in-service date and implementation programme if the service is to be introduced in phases.',
                label: 'Please attached required information',
                type: 'text',
                span: 12
            },
            {
                id: 'proposed-service-and-market-served-details',
                label: 'Proposed Service and Market Served Details',
                type: 'text',
                span: 12
            },
            {
                id: 'target-customers',
                label: 'Target Customers',
                type: 'lists',
                span: 12
            }
        ]
    },
    {
        sectionID: COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES,
        sectionName: 'Commencement of provision and/or operation of telecommunication services',
        fieldList: [
            {
                id: 'have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application',
                mainLabel: 'Provisioning/operation of any of the telecommunication services',
                label: 'Have you commenced provision/operation of any of the telecommunications services applied for in this application?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-state-the-date-of-commencement',
                label: 'Please state the date of commencement',
                type: 'text',
                span: 12
            },
            {
                id: 'number-of-users',
                label: 'Number of users',
                type: 'text',
                span: 12
            },
            {
                id: 'profile-of-users',
                label: 'Profile of users',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: SYSTEM_CONFIGURATION_AND_OPERATION,
        sectionName: 'System Configuration and Operation',
        fieldList: [
            {
                id: 'required-information-will-be-attached',
                mainLabel:
                    "Describe the technical and operational systems configuration for the proposed services and how the systems will be connected with other Facilities-Based Operators and/or Services-Based Operators network/systems, and/or other operator's network/systems overseas. Describe also the operation of the proposed services, e.g, the dialling procedures or call set-up arrangements.",
                mainSubLabel:
                    "[p] Provide a schematic diagram illustrating the proposed network/system platform to be interconnected with other Facilities-Based Operators, number of ITU-T Signalling System Number 7 signalling point codes (both local signalling point code and overseas signalling point code), if applicable, and call routing arrangement. [/p] [p] Please also include other associated customer's telecommunication equipment used to provide the proposed services. It should include the parties connected with and the transmission media for connection, eg., switched or leased circuits. [/p]",
                label: 'Required information will be attached',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: TELECOMMUNICATION_PARTNERS,
        sectionName: 'Telecommunication Partners',
        fieldList: [
            {
                id: 'telecommunication-partners',
                label: "Indicate any other telecommunication operators both in Singapore and Overseas with whom the applicant has, or intends to have, a commercial relationship, e.g, operator(s) who will be provide the applicant with international leased lines and/or other arrangements to carry the applicant's traffic.",
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: INTERNATIONAL_GATEWAYS,
        sectionName: 'International Gateways',
        fieldList: [
            {
                id: 'international-gateways',
                label: 'List any authorisation the applicant has obtained to run gateways overseas.',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_TECHNICAL_SUPPORT,
        sectionName: 'Other Technical Support',
        fieldList: [
            {
                id: 'other-technical-support',
                label: 'Include other technical and operational support facilities for the operation and maintenance of the networks/systems and the services.',
                type: 'text',
                span: 12
            },
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: NUMBERING_REQUIREMENT,
        sectionName: 'Numbering Requirement',
        fieldList: [
            {
                id: 'numbering-requirement',
                mainSubLabel:
                    '[p] i) Indicate the numbering format and access code to be used (e.g 1800-1234567), Describe how the access code would be used in providing service to customers and include the (a) network routing schemes and (b) diagram showing number signalling sequence between calling customer equipment and the local network. [/p] [p] ii) If a 4-digit access code is required, please state (a) justifications for requirement (b) an operational difficulties or constraints if such an access code is not granted. [/p] [p] iii) For more details on the procedure and application of 4-digit short codes, please refer to https://www.imda.gov.sg/regulations-and-licensing-listing/numbering/national-numbering-plan-and-allocation-process. [/p]',
                label: '',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: INFORMATION_OF_BOARD_OF_DIRECTORS_CEO,
        sectionName: 'Information of Board of Directors/CEO',
        fieldList: [
            {
                id: 'information-of-board-of-directors-ceo',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'designation',
                        header: 'Designation',
                        type: 'text'
                    },
                    {
                        id: 'full-name',
                        header: 'Full Name',
                        type: 'text'
                    },
                    {
                        id: 'identification-no',
                        header: 'Identification No.',
                        type: 'text'
                    },
                    {
                        id: 'identification-type',
                        header: 'Identification Type',
                        type: 'text'
                    },
                    {
                        id: 'others',
                        header: 'Others',
                        type: 'text'
                    },
                    {
                        id: 'spr',
                        header: 'SPR?',
                        type: 'text'
                    },
                    {
                        id: 'national',
                        header: 'National',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: INFORMATION_OF_BOARD_OF_DIRECTORS_CEO_FROM_EDH_ACRA,
        sectionName: 'Information of Board of Directors/CEO - From EDH-ACRA',
        fieldList: [
            {
                id: 'information-of-board-of-directors-ceo-from-edh-acra',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'identification-no',
                        header: 'Identification No.',
                        type: 'text'
                    },
                    {
                        id: 'identification-type',
                        header: 'Identification Type',
                        type: 'text'
                    },
                    {
                        id: 'name',
                        header: 'Name',
                        type: 'text'
                    },
                    {
                        id: 'national',
                        header: 'National',
                        type: 'text'
                    },
                    {
                        id: 'addresss',
                        header: 'Address',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: PUBLIC_INTERNET_ACCESS_SERVICES,
        sectionName: 'Public Internet Access Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES,
        sectionName: 'Registration for Public Internet Access Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID,
        sectionName: 'Public Internet Access Services - Non Prepaid',
        fieldList: [
            {
                id: 'wifi-connectivity',
                mainLabel: 'Wi-Fi Connectivity',
                label: 'If you intend to provide Wi-Fi connectivity to your subscribers, please confirm that the provision of Wi-Fi connectivity as part of any proposed Internet access services is restricted to localised on-site coverage (i.e., the operation of the telecommunication systems must not cross public roads or property not belonging to the operator or premise owner) with the following frequencies and output limits: i) 2.400 - 2.4835 GHz [<=200 mW EIRP]; ii) 5.150 - 5.350 GHz [<=200 mW EIRP]; iii) 5.470 - 5.275 GHz [<=1 W EIRP]; iv) 5.725 - 5875 GHz [<= 1 W EIRP]; and v) 57.00 - 66.00 GHz [<=10 W EIRP]. as prescribed in the Telecommunications Act 1999 Telecommunications (Exemption from Section 33, 34(1)(b) and 35) Notification.',
                type: 'text',
                span: 12
            },
            {
                id: 'in-principal-approval',
                mainLabel: 'In-principal Approval',
                label: 'Have you obtained any in-principal approval from the building owners or relevant agencies for installing your access points at their premises/properties?',
                type: 'text',
                span: 12
            },
            {
                id: 'internet-services-company',
                mainLabel: 'Internet Services Company',
                label: 'From which company do you intend to obtain the internet services for reselling to your customers?',
                type: 'text',
                span: 12
            },
            {
                id: 'intention-to-charge-for-usage',
                mainLabel: 'Intention To Charge for Usage',
                label: 'Do you intend to charge your customers for the usage of Internet access services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID,
        sectionName: 'Public Internet Access Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'wifi-connectivity',
                mainLabel: 'Wi-Fi Connectivity',
                label: 'If you intend to provide Wi-Fi connectivity to your subscribers, please confirm that the provision of Wi-Fi connectivity as part of any proposed Internet access services is restricted to localised on-site coverage (i.e., the operation of the telecommunication systems must not cross public roads or property not belonging to the operator or premise owner) with the following frequencies and output limits: i) 2.400 - 2.4835 GHz [<=200 mW EIRP]; ii) 5.150 - 5.350 GHz [<=200 mW EIRP]; iii) 5.470 - 5.275 GHz [<=1 W EIRP]; iv) 5.725 - 5875 GHz [<= 1 W EIRP]; and v) 57.00 - 66.00 GHz [<=10 W EIRP]. as prescribed in the Telecommunications Act 1999 Telecommunications (Exemption from Section 33, 34(1)(b) and 35) Notification.',
                type: 'text',
                span: 12
            },
            {
                id: 'in-principal-approval',
                mainLabel: 'In-principal Approval',
                label: 'Have you obtained any in-principal approval from the building owners or relevant agencies for installing your access points at their premises/properties?',
                type: 'text',
                span: 12
            },
            {
                id: 'internet-services-company',
                mainLabel: 'Internet Services Company',
                label: 'From which company do you intend to obtain the internet services for reselling to your customers?',
                type: 'text',
                span: 12
            },
            {
                id: 'intention-to-charge-for-usage',
                mainLabel: 'Intention To Charge for Usage',
                label: 'Do you intend to charge your customers for the usage of Internet access services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: OTHERS_SERVICES,
        sectionName: 'Others Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_OTHER_SERVICES,
        sectionName: 'Registration for Other Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: OTHER_SERVICES_NON_PREPAID,
        sectionName: 'Other Services - Non Prepaid',
        fieldList: [
            {
                id: 'description',
                label: 'Description',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: OTHER_SERVICES_PREPAID,
        sectionName: 'Other Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'description',
                label: 'Description',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES,
        sectionName: 'Resale of Local Leased Fixed-line Connectivity Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES,
        sectionName: 'Registration for Resale of Local Leased Fixed-line Connectivity Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID,
        sectionName: 'Resale of Local Leased Fixed-line Connectivity Services - Non Prepaid',
        fieldList: [
            {
                id: 'sbo-fbo-operator',
                mainLabel: 'SBO/FBO Operator',
                label: 'From which licenced SBO/FBO operator do you intend to obtain the Leased line services?',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-resell-dark-fibre',
                label: 'Do You Intend To Rresell Dark Fibre?',
                type: 'text',
                span: 12
            },
            {
                id: 'activation-of-iru-or-lit-international-dark-fibre',
                mainLabel: 'Activation of IRU or Lit International Dark Fibre',
                label: 'Will you activate your own Indefeasible-Right-of-Use("IRU") capacity or lit international dark fibre?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID,
        sectionName: 'Resale of Local Leased Fixed-line Connectivity Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'sbo-fbo-operator',
                mainLabel: 'SBO/FBO Operator',
                label: 'From which licenced SBO/FBO operator do you intend to obtain the Leased line services?',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-resell-dark-fibre',
                label: 'Do You Intend To Rresell Dark Fibre?',
                type: 'text',
                span: 12
            },
            {
                id: 'activation-of-iru-or-lit-international-dark-fibre',
                mainLabel: 'Activation of IRU or Lit International Dark Fibre',
                label: 'Will you activate your own Indefeasible-Right-of-Use("IRU") capacity or lit international dark fibre?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNATIONAL_CALLING_CARD_SERVICES,
        sectionName: 'International Calling Card Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES,
        sectionName: 'Registration for International Calling Card Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: INTERNATIONAL_CALLING_CARD_SERVICES_PREPAID,
        sectionName: 'International Calling Card Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES,
        sectionName: 'White Space Geo-Location Database Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES,
        sectionName: 'Registration for White Space Geo-Location Database Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES_PREPAID,
        sectionName: 'White Space Geo-Location Database Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: IP_TELEPHONY_SERVICES,
        sectionName: 'IP Telephony Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_IP_TELEPHONY_SERVICES,
        sectionName: 'Registration for IP Telephony Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: IP_TELEPHONY_SERVICES_NON_PREPAID,
        sectionName: 'IP Telephony Services - Non Prepaid',
        fieldList: [
            {
                id: 'non-prepaid',
                label: 'Non-Prepaid',
                type: 'lists',
                span: 12
            },
            {
                id: 'non-prepaid-others',
                label: 'Non-Prepaid - Others',
                type: 'text',
                span: 12
            },
            {
                id: 'party-responsible-for-the-subscriber-records',
                mainLabel: 'Party Responsible For The Subscriber Records',
                label: 'Who is the party responsible for the subscriber records of customers?',
                type: 'text',
                span: 12
            },
            {
                id: 'storage-of-subscriber-records',
                mainLabel: 'Storage of Subscriber Records',
                label: 'Will the subscriber records be kept in Singapore?',
                type: 'text',
                span: 12
            },
            {
                id: 'maintenance-party-of-the-cdrs',
                mainLabel: 'Maintenance Party Of The CDRs',
                label: 'Who is the party maintaining the Call Detail Records ("CDRs") of all calls made and received through the service?',
                type: 'text',
                span: 12
            },
            {
                id: 'cdrs-storage-in-singapore',
                mainLabel: 'CDRs Storage in Singapore',
                label: 'Will the CDRs be stored in Singapore?',
                type: 'text',
                span: 12
            },
            {
                id: 'cdrs-retention-period',
                mainLabel: 'CDRs Retention Period',
                label: 'How long will the CDRs be kept?',
                type: 'text',
                span: 12
            },
            {
                id: 'manipulation-of-calling-line-identity',
                mainLabel: 'Manipulation Of Calling Line Identity',
                label: 'Will the Calling Line Identity of the original calling party be manipulated?',
                type: 'text',
                span: 12
            },
            {
                id: 'passing-of-calling-line-identity',
                mainLabel: 'Passing Of Calling Line Identity',
                label: 'Is the original calling party Calling Line Identity passed on in the conveyance of a call accordingly?',
                type: 'text',
                span: 12
            },
            {
                id: 'masking-of-calling-line-identity',
                mainLabel: 'Masking Of Calling Line Identity',
                label: 'Does your IP Telephony Services perform any masking of Calling Line Identity of the calling party and/or called party?',
                type: 'text',
                span: 12
            },
            {
                id: 'singapore-emergency-service-centres',
                mainLabel: 'Singapore Emergency Service Centres',
                label: 'Do you intend to enable your subscribers to contact Singapore emergency services centres?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-provide-the-country-location-of-the-servers',
                label: 'Please Provide The Countrty Location Of The Servers (i.e, CPaaS, SIP, etc)',
                type: 'text',
                span: 12
            },
            {
                id: 'authenticating-the-subscribers',
                mainLabel: 'Authenticating the Subscribers',
                label: 'How Does Your Company Authenticate The Subscribers In The Provision Of Voice Services?',
                type: 'text',
                span: 12
            },
            {
                id: 'applicants-are-required-to-complete-their-call-tests',
                mainLabel:
                    "Applicants are required to complete their call tests to the Singapore emergency call centres (i.e., '999', '995') before the submission of this application. Applicants may work directly or indirectly with the PSTN access providers to test their IP Telephony Services for their compliance with the licence conditions. The PSTN access providers role is to facilitate the test calls with the Singapore 999/995 emergency call centres.",
                mainSubLabel:
                    '[p] Our general requirements are: [/p] [p] a) Calls with 6-series numbers originated from Singapore are able to reach Singapore emergency centre. This would be applicable to 3-series numbers as well if applicant intends to enable 3-series numbers to be able to contact emergency services as well; [/p] [p] b) Caller Line Identity ("CLI") must be present for originating calls to emergency calls; and [/p] [p] c) Calls originated from overseas are not to reach Singapore emergency centre. [/p] [p] After the call tests have been completed, applicants are required to validate the test results and attach a declaration of the successful call tests and its test dates as part of this application. [/p]',
                label: '',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: IP_TELEPHONY_SERVICES_PREPAID,
        sectionName: 'IP Telephony Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'prepaid',
                label: 'Prepaid',
                type: 'lists',
                span: 12
            },
            {
                id: 'prepaid-others',
                label: 'Prepaid - Others',
                type: 'text',
                span: 12
            },
            {
                id: 'party-responsible-for-the-subscriber-records',
                mainLabel: 'Party Responsible For The Subscriber Records',
                label: 'Who is the party responsible for the subscriber records of customers?',
                type: 'text',
                span: 12
            },
            {
                id: 'storage-of-subscriber-records',
                mainLabel: 'Storage of Subscriber Records',
                label: 'Will the subscriber records be kept in Singapore?',
                type: 'text',
                span: 12
            },
            {
                id: 'maintenance-party-of-the-cdrs',
                mainLabel: 'Maintenance Party Of The CDRs',
                label: 'Who is the party maintaining the Call Detail Records ("CDRs") of all calls made and received through the service?',
                type: 'text',
                span: 12
            },
            {
                id: 'cdrs-storage-in-singapore',
                mainLabel: 'CDRs Storage in Singapore',
                label: 'Will the CDRs be stored in Singapore?',
                type: 'text',
                span: 12
            },
            {
                id: 'cdrs-retention-period',
                mainLabel: 'CDRs Retention Period',
                label: 'How long will the CDRs be kept?',
                type: 'text',
                span: 12
            },
            {
                id: 'manipulation-of-calling-line-identity',
                mainLabel: 'Manipulation Of Calling Line Identity',
                label: 'Will the Calling Line Identity of the original calling party be manipulated?',
                type: 'text',
                span: 12
            },
            {
                id: 'passing-of-calling-line-identity',
                mainLabel: 'Passing Of Calling Line Identity',
                label: 'Is the original calling party Calling Line Identity passed on in the conveyance of a call accordingly?',
                type: 'text',
                span: 12
            },
            {
                id: 'masking-of-calling-line-identity',
                mainLabel: 'Masking Of Calling Line Identity',
                label: 'Does your IP Telephony Services perform any masking of Calling Line Identity of the calling party and/or called party?',
                type: 'text',
                span: 12
            },
            {
                id: 'singapore-emergency-service-centres',
                mainLabel: 'Singapore Emergency Service Centres',
                label: 'Do you intend to enable your subscribers to contact Singapore emergency services centres?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-provide-the-country-location-of-the-servers',
                label: 'Please Provide The Countrty Location Of The Servers (i.e, CPaaS, SIP, etc)',
                type: 'text',
                span: 12
            },
            {
                id: 'authenticating-the-subscribers',
                mainLabel: 'Authenticating the Subscribers',
                label: 'How Does Your Company Authenticate The Subscribers In The Provision Of Voice Services?',
                type: 'text',
                span: 12
            },
            {
                id: 'applicants-are-required-to-complete-their-call-tests',
                mainLabel:
                    "Applicants are required to complete their call tests to the Singapore emergency call centres (i.e., '999', '995') before the submission of this application. Applicants may work directly or indirectly with the PSTN access providers to test their IP Telephony Services for their compliance with the licence conditions. The PSTN access providers role is to facilitate the test calls with the Singapore 999/995 emergency call centres.",
                mainSubLabel:
                    '[p] Our general requirements are: [/p] [p] a) Calls with 6-series numbers originated from Singapore are able to reach Singapore emergency centre. This would be applicable to 3-series numbers as well if applicant intends to enable 3-series numbers to be able to contact emergency services as well; [/p] [p] b) Caller Line Identity ("CLI") must be present for originating calls to emergency calls; and [/p] [p] c) Calls originated from overseas are not to reach Singapore emergency centre. [/p] [p] After the call tests have been completed, applicants are required to validate the test results and attach a declaration of the successful call tests and its test dates as part of this application. [/p]',
                label: '',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_SERVICES,
        sectionName: 'Voice And Data Services With Masking Of Calling Line Identity Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY,
        sectionName: 'Registration for Voice And Data Services With Masking Of Calling Line Identity',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_PREPAID,
        sectionName: 'Voice And Data Services With Masking Of Calling Line Identity - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MACHINE_TO_MACHINE_SERVICES,
        sectionName: 'Machine-to-Machine ("M2M") Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES,
        sectionName: 'Registration for Machine-to-Machine ("M2M") Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: MACHINE_TO_MACHINE_NON_PREPAID,
        sectionName: 'Machine-to-Machine ("M2M") - Non Prepaid',
        fieldList: [
            {
                id: 'm2m-sim-card-providers-name',
                mainLabel: "M2M SIM Card Provider's Name",
                label: 'Please provide the full name of the M2M Sim card provider, and its local entity if it is based overseas.',
                type: 'text',
                span: 12
            },
            {
                id: 'local-mobile-telecommunication-operators',
                mainLabel: 'Local Mobile Telecommunication Operators',
                label: 'If the M2M SIM card provider has established roaming agreements with local operators, please provide their full entity names',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-country-code',
                mainLabel: 'Please provide the M2M SIM cards following information:',
                label: 'Mobile Country Code',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-network-code',
                label: 'Mobile Network Code',
                type: 'text',
                span: 12
            },
            {
                id: 'international-mobile-subscriber-identifier-number-ranges',
                label: 'International Mobile Subscriber Identifier Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-station-integrated-services-digital-network-number-ranges',
                label: 'Mobile Station Integrated Services Digital Network Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'm2m-devices-international-mobile-equipment-identity-number-ranges',
                label: 'M2M Devices International Mobile Equipment Identity Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-provide-physical-sim-cards-or-esims-or-both',
                label: 'Do You Intend To Provide Physical SIM cards or eSIMs or Both?',
                type: 'text',
                span: 12
            },
            {
                id: 'are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls',
                label: 'Are The SIM cards And/Or eSIMS Enabled To Allow Voice or VoIP Calls?',
                type: 'text',
                span: 12
            },
            {
                id: 'are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres',
                label: 'Are The SIM cards Or eSIMS Enabled To Contact Singapore Emergency Centres?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-provide-the-country-that-the-m2m-data-will-be-stored-in',
                label: 'Please provide the country that the M2M data will be stored in',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MACHINE_TO_MACHINE_PREPAID,
        sectionName: 'Machine-to-Machine ("M2M") - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'm2m-sim-card-providers-name',
                mainLabel: "M2M SIM Card Provider's Name",
                label: 'Please provide the full name of the M2M Sim card provider, and its local entity if it is based overseas.',
                type: 'text',
                span: 12
            },
            {
                id: 'local-mobile-telecommunication-operators',
                mainLabel: 'Local Mobile Telecommunication Operators',
                label: 'If the M2M SIM card provider has established roaming agreements with local operators, please provide their full entity names',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-country-code',
                mainLabel: 'Please provide the M2M SIM cards following information:',
                label: 'Mobile Country Code',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-network-code',
                label: 'Mobile Network Code',
                type: 'text',
                span: 12
            },
            {
                id: 'international-mobile-subscriber-identifier-number-ranges',
                label: 'International Mobile Subscriber Identifier Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'mobile-station-integrated-services-digital-network-number-ranges',
                label: 'Mobile Station Integrated Services Digital Network Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'm2m-devices-international-mobile-equipment-identity-number-ranges',
                label: 'M2M Devices International Mobile Equipment Identity Number Ranges',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-provide-physical-sim-cards-or-esims-or-both',
                label: 'Do You Intend To Provide Physical SIM cards or eSIMs or Both?',
                type: 'text',
                span: 12
            },
            {
                id: 'are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls',
                label: 'Are The SIM cards And/Or eSIMS Enabled To Allow Voice or VoIP Calls?',
                type: 'text',
                span: 12
            },
            {
                id: 'are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres',
                label: 'Are The SIM cards Or eSIMS Enabled To Contact Singapore Emergency Centres?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-provide-the-country-that-the-m2m-data-will-be-stored-in',
                label: 'Please provide the country that the M2M data will be stored in',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_BASED_VOICE_AND_DATA_SERVICES,
        sectionName: 'Internet-Based Voice And Data Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES,
        sectionName: 'Registration for Internet-Based Voice And Data Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID,
        sectionName: 'Internet-Based Voice And Data Services - Non Prepaid',
        fieldList: [
            {
                id: 'please-provide-the-country-location-of-the-servers',
                label: 'Please Provide The Country Location Of The Servers (i.e, CPaaS, SIP, etc).',
                type: 'text',
                span: 12
            },
            {
                id: 'authentication-method',
                mainLabel: 'Authentication Method',
                label: 'How Does Your Company Authenticate The Subscribers In The Provision Of Voice Services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID,
        sectionName: 'Internet-Based Voice And Data Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'please-provide-the-country-location-of-the-servers',
                label: 'Please Provide The Country Location Of The Servers (i.e, CPaaS, SIP, etc).',
                type: 'text',
                span: 12
            },
            {
                id: 'authentication-method',
                mainLabel: 'Authentication Method',
                label: 'How Does Your Company Authenticate The Subscribers In The Provision Of Voice Services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNATIONAL_SIMPLE_RESALE_SERVICES,
        sectionName: 'International Simple Resale Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES,
        sectionName: 'Registration for International Simple Resale Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: INTERNATIONAL_SIMPLE_RESALE_SERVICES_NON_PREPAID,
        sectionName: 'International Simple Resale Services - Non Prepaid',
        fieldList: [
            {
                id: 'short-code-for-voice-services',
                label: 'Do you intend to assign any short code for the provision of voice services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID,
        sectionName: 'International Simple Resale Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'short-code-for-voice-services',
                label: 'Do you intend to assign any short code for the provision of voice services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_EXCHANGE_SERVICES,
        sectionName: 'Internet Exchange Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES,
        sectionName: 'Registration for Internet Exchange Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_EXCHANGE_SERVICES_NON_PREPAID,
        sectionName: 'Internet Exchange Services - Non Prepaid',
        fieldList: [
            {
                id: 'entity-peer',
                mainLabel: 'Entity Peer',
                label: 'Which entity will you be peering with for the provision of Internet Exchange Services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: INTERNET_EXCHANGE_SERVICES_PREPAID,
        sectionName: 'Internet Exchange Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'entity-peer',
                mainLabel: 'Entity Peer',
                label: 'Which entity will you be peering with for the provision of Internet Exchange Services?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: CALL_BACK_CALL_RE_ORIGINATION_SERVICES,
        sectionName: 'Call-back / Call Re-origination Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES,
        sectionName: 'Registration for Call-back / Call Re-origination Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: CALL_BACK_CALL_RE_ORIGINATION_SERVICES_PREPAID,
        sectionName: 'Call-back / Call Re-origination Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES,
        sectionName: 'Store-and-Retrieve Value-Added Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES,
        sectionName: 'Registration for Store-and-Retrieve Value-Added Network Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES_PREPAID,
        sectionName: 'Store-and-Retrieve Value-Added Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: STORE_AND_FORWARD_VALUE_ADDED_SERVICES,
        sectionName: 'Store-and-Forward Value-Added Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES,
        sectionName: 'Registration for Store-and-Forward Value-Added Network Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: STORE_AND_FORWARD_VALUE_ADDED_SERVICES_PREPAID,
        sectionName: 'Store-and-Forward Value-Added Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES,
        sectionName: 'Satellite Mobile Telephone or Data Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES,
        sectionName: 'Registration for Satellite Mobile Telephone or Data Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES_PREPAID,
        sectionName: 'Satellite Mobile Telephone or Data Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
        sectionName: 'Resale of Public Switched Telecommunication Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
        sectionName: 'Registration for Resale of Public Switched Telecommunication Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES_PREPAID,
        sectionName: 'Resale of Public Switched Telecommunication Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: VIRTUAL_PRIVATE_NETWORK_SERVICES,
        sectionName: 'Virtual Private Network Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES,
        sectionName: 'Registration for Virtual Private Network Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: VIRTUAL_PRIVATE_NETWORK_SERVICES_NON_PREPAID,
        sectionName: 'Registration for Virtual Private Network Services - Non Prepaid',
        fieldList: [
            {
                id: 'vpn-services',
                mainLabel: 'VPN Services',
                label: 'Will you be reselling VPN Services from another service provider?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID,
        sectionName: 'Registration for Virtual Private Network Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'vpn-services',
                mainLabel: 'VPN Services',
                label: 'Will you be reselling VPN Services from another service provider?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: LIVE_AUDIOTEX_SERVICES,
        sectionName: 'Live Audiotex Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES,
        sectionName: 'Registration for Live Audiotex Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: LIVE_AUDIOTEX_SERVICES_PREPAID,
        sectionName: 'Live Audiotex Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES,
        sectionName: 'Mobile Virtual Network Operation Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES,
        sectionName: 'Registration for Mobile Virtual Network Operation Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID,
        sectionName: 'Mobile Virtual Network Operation Services - Non Prepaid',
        fieldList: [
            {
                id: 'name-of-mobile-virtual-network-enabler',
                mainLabel: 'Name of Mobile Virtual Network Enabler',
                label: 'Please provide the full entity name of the Mobile Virtual Network Enabler',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-provide-physical-sim-cards-and-or-esims',
                label: 'Do You Intend To Provide Physical SIM cards and/or eSIMS?',
                type: 'text',
                span: 12
            },
            {
                id: 'know-your-customer-solution',
                mainLabel: 'Know Your Customer ("eKYC") solution',
                label: 'Do you intend to implement and/or use any electronic Know Your Customer ("eKYC") solution to remotely register your subscribers for postpaid and/or prepaid cellular mobile telecommunication services?',
                type: 'text',
                span: 12
            },
            {
                id: 'measures-for-ekyc-solution',
                mainLabel: 'Please Attach Your eKYC Flow Diagram And Its Description With Screenshots As Part Of This Application',
                mainSubLabel: '[p] Measures For eKYC Solution [/p]',
                label: "Which of the following measures does your eKYC solution employ in order to identify and verify a subscriber's identity?",
                type: 'lists',
                span: 12
            },
            {
                id: 'delivery-and-activation-processes',
                mainLabel: 'Delivery And Activation Processes',
                label: 'Please provide descriptions of the delivery and activation processes for your physical SIM cards and eSIMS',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID,
        sectionName: 'Mobile Virtual Network Operation Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'name-of-mobile-virtual-network-enabler',
                mainLabel: 'Name of Mobile Virtual Network Enabler',
                label: 'Please provide the full entity name of the Mobile Virtual Network Enabler',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-provide-physical-sim-cards-and-or-esims',
                label: 'Do You Intend To Provide Physical SIM cards and/or eSIMS?',
                type: 'text',
                span: 12
            },
            {
                id: 'know-your-customer-solution',
                mainLabel: 'Know Your Customer ("eKYC") solution',
                label: 'Do you intend to implement and/or use any electronic Know Your Customer ("eKYC") solution to remotely register your subscribers for postpaid and/or prepaid cellular mobile telecommunication services?',
                type: 'text',
                span: 12
            },
            {
                id: 'measures-for-ekyc-solution',
                mainLabel: 'Please Attach Your eKYC Flow Diagram And Its Description With Screenshots As Part Of This Application',
                mainSubLabel: '[p] Measures For eKYC Solution [/p]',
                label: "Which of the following measures does your eKYC solution employ in order to identify and verify a subscriber's identity?",
                type: 'lists',
                span: 12
            },
            {
                id: 'delivery-and-activation-processes',
                mainLabel: 'Delivery And Activation Processes',
                label: 'Please provide descriptions of the delivery and activation processes for your physical SIM cards and eSIMS',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES,
        sectionName: 'Mobile Communication On Aircraft Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES,
        sectionName: 'Registration for Mobile Communication On Aircraft Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES_PREPAID,
        sectionName: 'Mobile Communication On Aircraft Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MANAGED_DATA_NETWORK_SERVICES,
        sectionName: 'Managed Data Network Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES,
        sectionName: 'Registration for Managed Data Network Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: MANAGED_DATA_NETWORK_SERVICES_NON_PREPAID,
        sectionName: 'Managed Data Network Services - Non Prepaid',
        fieldList: [
            {
                id: 'which-of-the-following-features-do-you-intend-to-provide',
                label: 'Which Of The Following Features Do You Intend To Provide?',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`];
                const result = !value?.includes('Non Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: MANAGED_DATA_NETWORK_SERVICES_PREPAID,
        sectionName: 'Managed Data Network Services - Prepaid',
        fieldList: [
            {
                id: 'hotline-enquiry-number-for-prepaid-services',
                mainLabel:
                    'Note: Prepaid services refer to any collection of monetary deposits or use of prepaid cards for the collection of payments from its customers.',
                label: 'Hotline Enquiry Number for Prepaid Services',
                type: 'text',
                span: 12
            },
            {
                id: 'which-of-the-following-features-do-you-intend-to-provide',
                label: 'Which Of The Following Features Do You Intend To Provide?',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`];
                const result = !value?.includes('Prepaid');
                return result;
            }
        }
    },
    {
        sectionID: NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES,
        sectionName: 'Number Portability Centralised Database Services',
        fieldList: [],
        rule: {
            baseIds: [`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES,
        sectionName: 'Registration for Number Portability Centralised Database Services',
        fieldList: [
            {
                id: 'plan-type',
                label: 'Plan Type',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any =
                    baseValues && baseValues[`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`];
                const result = Boolean(value.length === 0);
                return result;
            }
        }
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
